"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var redux_observable_1 = require("redux-observable");
var types_1 = require("../actions/internal/types");
var operators_1 = require("rxjs/operators");
var util_1 = require("./util");
var individualResults_1 = require("../actions/internal/individualResults");
var lodash_1 = require("lodash");
var params_1 = require("./util/params");
function findIdOrBib(args) {
    var athlinksEntryId = args.athlinksEntryId, thirdPartyEntryId = args.thirdPartyEntryId, bib = args.bib;
    if (thirdPartyEntryId)
        return { id: thirdPartyEntryId };
    if (!lodash_1.isEmpty(bib))
        return { bib: bib };
    if (athlinksEntryId)
        return { id: athlinksEntryId };
    throw new Error('You must specify at least one of the following: ' +
        '[ athlinksEntryId | thirdPartyEntryId | bib]');
}
exports.findIdOrBib = findIdOrBib;
function buildIndividualResultsQueryString(action) {
    var _a = action.args, eventId = _a.eventId, eventCourseId = _a.eventCourseId;
    var _b = findIdOrBib(action.args), id = _b.id, bib = _b.bib;
    return 'individual' +
        params_1.formatParams([
            { id: id },
            { bib: bib },
            { eventId: eventId },
            { eventCourseId: eventCourseId }
        ]);
}
exports.buildIndividualResultsQueryString = buildIndividualResultsQueryString;
function startIndividualResultsPolling(actions$) {
    return actions$.pipe(redux_observable_1.ofType(types_1.InternalClientActionType.GET_INDIVIDUAL_RESULTS_DATA), operators_1.flatMap(function (action$) {
        var pollingInterval = action$.pollingInterval, args = action$.args;
        return rxjs_1.from(util_1.pollForData(args, buildIndividualResultsQueryString(action$), pollingInterval, individualResults_1.getIndividualResultsUpdateInternal, individualResults_1.getIndividualResultsStartedInternal(args), individualResults_1.getIndividualResultsErrorInternal)).pipe(operators_1.catchError(function (err) { return rxjs_1.of(err); }));
    }), operators_1.catchError(function (err) { return rxjs_1.of(err); }));
}
exports.startIndividualResultsPolling = startIndividualResultsPolling;
function stopIndividualResultsPolling(actions$) {
    return actions$.pipe(redux_observable_1.ofType(types_1.InternalClientActionType.GET_INDIVIDUAL_RESULTS_DATA_STOP_POLLING), operators_1.flatMap(function (action$) {
        return rxjs_1.from(util_1.stopPolling(action$.args, buildIndividualResultsQueryString(action$), individualResults_1.getIndividualResultsStoppedInternal(action$.args), individualResults_1.getIndividualResultsErrorInternal)).pipe(operators_1.catchError(function (err) { return rxjs_1.of(err); }));
    }));
}
exports.stopIndividualResultsPolling = stopIndividualResultsPolling;
//# sourceMappingURL=individualResultsEpic.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/epics/individualResultsEpic.js
 ** module id = 2076
 ** module chunks = 0
 **/